export default "__VITE_ASSET__0e1ffcd0__"